import {
  Anchor, Target, Zap, Eye,
  Shield, UserX, Compass,
  Footprints, Crosshair, Magnet,
} from 'lucide-react';

// Single source of truth for player trait visuals.
// Categories: offensive (rosso), defensive (blu), transversal (verde).
export const TRAIT_META = {
  boa:        { icon: Anchor,     category: 'offensive'   },
  bomber:     { icon: Target,     category: 'offensive'   },
  folletto:   { icon: Zap,        category: 'offensive'   },
  regista:    { icon: Eye,        category: 'offensive'   },
  muro:       { icon: Shield,     category: 'defensive'   },
  marcatore:  { icon: UserX,      category: 'defensive'   },
  libero:     { icon: Compass,    category: 'defensive'   },
  maratoneta: { icon: Footprints, category: 'transversal' },
  cecchino:   { icon: Crosshair,  category: 'transversal' },
  collante:   { icon: Magnet,     category: 'transversal' },
};

export const CATEGORY_STYLE = {
  offensive: {
    label: 'Off',
    badge: 'bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950/40 dark:text-rose-300 dark:border-rose-900',
    icon: 'text-rose-600 dark:text-rose-400',
    dot: 'bg-rose-500',
  },
  defensive: {
    label: 'Dif',
    badge: 'bg-sky-50 text-sky-700 border-sky-200 dark:bg-sky-950/40 dark:text-sky-300 dark:border-sky-900',
    icon: 'text-sky-600 dark:text-sky-400',
    dot: 'bg-sky-500',
  },
  transversal: {
    label: 'Trasv',
    badge: 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-900',
    icon: 'text-emerald-600 dark:text-emerald-400',
    dot: 'bg-emerald-500',
  },
};

export function getTraitStyle(catalogEntry) {
  const meta = TRAIT_META[catalogEntry?.key] || {};
  const cat = meta.category || catalogEntry?.category || 'transversal';
  return {
    Icon: meta.icon,
    category: cat,
    style: CATEGORY_STYLE[cat] || CATEGORY_STYLE.transversal,
  };
}

// Attacking/defending attitude (calcetto); mirrors models.SPORT_ATTRIBUTES.
export const PLAY_STYLES = [
  { key: 'offensive', label: 'Offensivo' },
  { key: 'balanced', label: 'Equilibrato' },
  { key: 'defensive', label: 'Difensivo' },
];
